<template>
  <AModal
    v-bind="$attrs"
    :title="null"
    :footer="null"
    width="660px"
    @cancel="$emit('update:visible', false)"
  >
    <ATabs
      :default-active-key="tabKeys.FORM"
      class="layout-apply-bonus"
      @change="onTabChange"
    >
      <ATabPane :key="tabKeys.FORM" tab="申请算力豆">
        <AFormModel
          ref="applyForm"
          :model="applyForm"
          :rules="applyRules"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 19 }"
          hideRequiredMark
          label-width="80px"
          size="small"
          class="apply-bonus-form"
        >
          <AFormModelItem label="申请个数" prop="amount">
            <div class="mp-flex amount">
              <mp-input-number
                v-model="applyForm.amount"
                :min="1"
                :max="1000"
                :precision="0"
                class="input-number"
              />颗
            </div>
          </AFormModelItem>
          <AFormModelItem label="申请课程" prop="course">
            <ASelect
              v-model="applyForm.course"
              :disabled="submitLoading"
              placeholder="请选择课程"
              @change="onCourseSelected"
            >
              <ASelectOption
                v-for="item in joinedCourses"
                :key="item.id"
                :value="item.group.id"
              >
                {{ item.group.name }}
              </ASelectOption>
            </ASelect>
          </AFormModelItem>
          <AFormModelItem label="申请理由" prop="reason">
            <AInput
              v-model="applyForm.reason"
              placeholder="申请理由限制16个字符。"
            />
          </AFormModelItem>
          <div v-if="showCustomError" class="custom-error">
            本课程的上一次申请正在等待老师审核
          </div>
          <AButton
            :disabled="showCustomError"
            :loading="submitLoading"
            type="primary"
            class="btn-submit"
            @click="submitForm('ruleForm')"
          >
            提交
          </AButton>
        </AFormModel>
      </ATabPane>
      <ATabPane :key="tabKeys.DATA" tab="申请历史">
        <ATable
          v-if="fetchLoading || applyHistories.length"
          :data-source="applyHistories"
          :loading="fetchLoading"
          :pagination="{ ...pagination, hideOnSinglePage: true }"
          rowKey="rowKey"
          class="history-table"
          @change="onTableChange"
        >
          <ATableColumn title="申请时间" data-index="time" />
          <ATableColumn title="数量" data-index="account" />
          <ATableColumn title="课程" data-index="courseName" />
          <ATableColumn title="申请状态" data-index="status">
            <span slot-scope="text, record" :class="record.statusClass">
              {{ text }}
            </span>
          </ATableColumn>
          <ATableColumn title="审核结果" data-index="result" />
        </ATable>
        <div v-else class="history-default">
          <img src="@/assets/images/default-table.svg" alt="default" />
          <div>暂无记录</div>
        </div>
      </ATabPane>
    </ATabs>
  </AModal>
</template>

<script>
import { Tabs } from 'ant-design-vue'
import { mapState } from 'vuex'
import groupApi from '@/api/group'
import MpInputNumber from '@/components/mp-input-number'
import { formatCent, formatDate } from '@/utils/filter'

const BONUS_MONEY = 2
const STATUS_APPLY = 1
const STATUS_PASS = 2
const STATUS = {
  [STATUS_APPLY]: {
    label: '申请中',
    className: ''
  },
  [STATUS_PASS]: {
    label: '申请通过',
    className: 'success'
  },
  3: {
    label: '申请失败',
    className: 'error'
  }
}

export default {
  name: 'ApplyBonus',
  components: {
    [Tabs.name]: Tabs,
    [Tabs.TabPane.name]: Tabs.TabPane,
    MpInputNumber
  },
  data() {
    const validateAmount = (rule, value, callback) => {
      if (Number.isNaN(Number(value))) {
        callback(new Error('个数必须为数字'))
      } else if (Number(value) <= 0) {
        callback(new Error('个数必须为大于0'))
      } else {
        callback()
      }
    }
    return {
      tabKeys: {
        FORM: 1,
        DATA: 2
      },
      applyForm: {
        amount: 1,
        course: '',
        reason: ''
      },
      applyRules: {
        amount: [
          { required: true, message: '请输入申请数量', trigger: 'blur' },
          { validator: validateAmount, trigger: 'blur' }
        ],
        course: [{ required: true, message: '请选择课程', trigger: 'blur' }],
        reason: [
          { required: true, message: '请输入申请理由', trigger: 'blur' },
          { pattern: /\S/, message: '请输入非空字符', trigger: 'blur' },
          { max: 16, message: '最多16个字', trigger: 'blur' }
        ]
      },
      showCustomError: false,
      submitLoading: false,

      applyHistories: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 6
      },
      fetchLoading: false
    }
  },
  computed: {
    ...mapState({
      joinedCourses: state => state.course.joinedCourses
    })
  },
  methods: {
    submitForm() {
      this.$refs.applyForm.validate(async valid => {
        if (valid) {
          if (this.submitLoading) {
            return
          }
          this.submitLoading = true
          const params = {
            group_id: +this.applyForm.course,
            type: BONUS_MONEY,
            amount: formatCent(this.applyForm.amount, true),
            reason: this.applyForm.reason.trim()
          }

          const resData = await groupApi.applyGroupBonus(params, {
            errMsg: {
              106: '你已经申请过该课程，请勿重复申请',
              default: '申请算力豆出错了'
            }
          })
          this.submitLoading = false

          if (resData.code === 0) {
            this.$message.success('算力豆申请成功，已经通知老师进行审批')
            this.$refs.applyForm.resetFields()
            this.$emit('update:visible', false)
          }
        } else {
          return false
        }
      })
    },

    async fetchHistories(page) {
      this.fetchLoading = true
      const { code, pagination, requests } = await groupApi.getApplyHistory({
        type: BONUS_MONEY,
        page: page || this.pagination.current,
        per_page: this.pagination.pageSize
      })
      this.fetchLoading = false

      if (code === 0) {
        this.applyHistories = requests.map((r, i) => {
          const { request } = r.member
          const { cent, acquiredCent } = request.moneyBonusDetails
          const isPass = request.status === STATUS_PASS
          const statusObj = STATUS[request.status] || {}

          return {
            rowKey: i,
            time: formatDate(request.createTime),
            account: formatCent(cent),
            courseName: r.group.name,
            status: statusObj.label || '-',
            statusClass: statusObj.className || '',
            result: isPass ? `获得${formatCent(acquiredCent)}颗算力豆` : '-'
          }
        })
        this.pagination.current = pagination.page
        this.pagination.total = pagination.total
      }
    },

    onTabChange(key) {
      if (key === this.tabKeys.DATA) {
        this.fetchHistories()
      }
    },
    async onCourseSelected(course) {
      this.submitLoading = true
      const { code, request } = await groupApi.getGroupApply(
        {
          type: BONUS_MONEY,
          group_id: +course
        },
        { noErrMsg: true }
      )
      this.submitLoading = false

      if (code === 0 && request && request.status === STATUS_APPLY) {
        this.$refs.applyForm.clearValidate()
        this.applyForm.amount = formatCent(request.moneyBonusDetails.cent)
        this.applyForm.reason = request.reason
        this.showCustomError = true
      } else {
        this.showCustomError = false
      }
    },
    onTableChange(pagination) {
      const { current } = pagination
      this.fetchHistories(current)
    }
  }
}
</script>

<style lang="less" scoped>
.apply-bonus-form {
  width: 395px;
  margin: @spacing-4x auto 0;
}
.amount {
  white-space: nowrap;
  .input-number {
    margin-right: 12px;
  }
}
.el-input-number--small {
  width: 150px;
}
.el-select {
  width: 100%;
}
.custom-error {
  color: #f5222d;
  margin: 0 0 8px;
  line-height: 22px;
  text-align: center;
}
.btn-submit {
  display: block;
  width: 110px;
  height: 36px;
  margin: 0 auto;
}

.history-default {
  margin: @spacing-8x 0;
  text-align: center;
}

.history-table {
  ::v-deep .ant-table {
    color: #777684;
  }

  .success {
    color: #2dbb59;
  }
  .error {
    color: #ec606c;
  }
}
</style>
<style lang="less">
.layout-apply-bonus.ant-tabs {
  margin-top: -8px;
  color: #777684;
  min-height: 286px;

  .ant-tabs-bar {
    text-align: center;
    border-bottom: none;
  }
  .ant-tabs-ink-bar-animated {
    visibility: hidden;
  }
  .ant-tabs-nav-container {
    font-size: 20px;
    line-height: 28px;
  }
  .ant-tabs-nav .ant-tabs-tab {
    margin-right: 0;
    padding: 0 16px;
  }
  .ant-tabs-tab-active {
    color: @primary;
  }
}
</style>
